function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.48 2H8.52C5.07 2 3 4.06 3 7.52v7.95C3 18.94 5.07 21 8.52 21h7.95c3.46 0 5.52-2.06 5.52-5.52V7.52C22 4.06 19.93 2 16.48 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 16.15v2.7C11 21.1 10.1 22 7.85 22h-2.7C2.9 22 2 21.1 2 18.85v-2.7C2 13.9 2.9 13 5.15 13h2.7c2.25 0 3.15.9 3.15 3.15zm1.262-5.1a.798.798 0 00.06.28c.03.07.08.14.13.19.02.02.04.04.06.05.05.04.1.08.15.1.02.01.05.02.07.03.08.03.17.05.26.05h4.02c.41 0 .75-.34.75-.75s-.33-.72-.75-.72h-2.21l3.74-3.75c.29-.29.29-.77 0-1.06a.742.742 0 00-.53-.22c-.19 0-.38.07-.53.22l-3.73 3.74v-2.2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v4.02c0 .01 0 .01.01.02z"
})));